import React from 'react';
import PropTypes from 'prop-types';

const FeedbackSuccess = ({ handleCloseButtonClick }) => (
  <div className="fp-feedbackSuccessBody">
    <div className="fp-feedbackSuccessBody__acknowledgement">
      <p className="fp-feedbackSuccessBody__thankYouMessage">
        Thank you for getting in touch
      </p>
      <p className="fp-feedbackSuccessBody__feedbackIsImportant">
        Your feedback is really important to us.
      </p>
    </div>
    <div className="fp-feedbackSuccessBody__wrapper">
      <button
        className="fp-feedbackSuccessBody__close gn-button gn-button--primary"
        onClick={handleCloseButtonClick}
      >
        Close Window
      </button>
    </div>
  </div>
);

FeedbackSuccess.propTypes = {
  handleCloseButtonClick: PropTypes.func.isRequired,
};

export default FeedbackSuccess;
